var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiskDrive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "-3.9 0 29.2 29.2",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#656766;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#53B2E4;}\r\n\t.st3{fill:#E8E4E7;}\r\n\t.st4{fill:#4D4C4D;}\r\n\t.st5{fill:#ED6F62;}\r\n\t.st6{fill:#FFCA65;}\r\n\t.st7{fill:#BABABA;}\r\n\t.st8{fill:#D3D3D3;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.3,29.2H2.1c-1.2,0-2.1-0.9-2.1-2.1v-25C0,0.9,0.9,0,2.1,0h17.2c1.2,0,2.1,0.9,2.1,2.1V27    C21.4,28.2,20.5,29.2,19.3,29.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3.6,21.4V5.8c0-1,0.8-1.7,1.7-1.7h10.6c1,0,1.7,0.8,1.7,1.7v15.6c0,1-0.8,1.7-1.7,1.7H5.3    C4.4,23.1,3.6,22.3,3.6,21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3.6,13.4v8c0,1,0.8,1.7,1.7,1.7h10.6c1,0,1.7-0.8,1.7-1.7v-4.2h-4.2C9.8,17.3,6.3,15.8,3.6,13.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 19.8,
    cy: 1.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 19.8,
    cy: 27.4,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 1.7,
    cy: 1.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 1.7,
    cy: 27.4,
    r: 0.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M17,29.2H4.4v-0.7c0-0.3,0.3-0.6,0.6-0.6h11.4c0.3,0,0.6,0.3,0.6,0.6V29.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M5.5,9.4l0.4-0.6c0.3,0.3,0.7,0.5,1.2,0.5c0.4,0,0.7-0.2,0.7-0.4c0-0.7-2.2-0.2-2.2-1.6     c0-0.6,0.5-1.1,1.4-1.1c0.6,0,1.1,0.2,1.5,0.5L8,7.3C7.7,7,7.3,6.9,6.9,6.9C6.6,6.9,6.4,7,6.4,7.3c0,0.6,2.2,0.2,2.2,1.6     c0,0.7-0.5,1.2-1.5,1.2C6.4,10,5.8,9.8,5.5,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M8.9,9.4l0.4-0.6c0.3,0.3,0.7,0.5,1.2,0.5c0.4,0,0.7-0.2,0.7-0.4C11.2,8.2,9,8.7,9,7.3     c0-0.6,0.5-1.1,1.4-1.1c0.6,0,1.1,0.2,1.5,0.5l-0.4,0.6c-0.3-0.3-0.7-0.4-1.1-0.4c-0.3,0-0.5,0.1-0.5,0.4c0,0.6,2.2,0.2,2.2,1.6     c0,0.7-0.5,1.2-1.5,1.2C9.7,10,9.2,9.8,8.9,9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12.5,10V6.3H14c1.2,0,2,0.7,2,1.9c0,1.1-0.8,1.9-2,1.9L12.5,10L12.5,10z M15.1,8.1c0-0.7-0.4-1.2-1.2-1.2     h-0.7v2.3H14C14.7,9.3,15.1,8.7,15.1,8.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 5.7,
    y: 27.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 6.7,
    y: 27.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 7.6,
    y: 27.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 8.6,
    y: 27.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 9.5,
    y: 27.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 10.5,
    y: 27.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 11.4,
    y: 27.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 12.4,
    y: 27.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 13.4,
    y: 27.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 14.3,
    y: 27.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 15.3,
    y: 27.8
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M19.3,29.2H2.1c-1.2,0-2.1-0.9-2.1-2.1V4.2C0,3,0.9,2.1,2.1,2.1h17.2c1.2,0,2.1,0.9,2.1,2.1v22.9    C21.4,28.2,20.5,29.2,19.3,29.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M19.3,27.2H2.1c-1.2,0-2.1-0.9-2.1-2.1v-23C0,0.9,0.9,0,2.1,0h17.2c1.2,0,2.1,0.9,2.1,2.1V25    C21.4,26.2,20.5,27.2,19.3,27.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3,22.7V4.5C3,3.7,3.7,3,4.5,3h12.4c0.8,0,1.5,0.7,1.5,1.5v18.2c0,0.8-0.7,1.5-1.5,1.5H4.5    C3.7,24.1,3,23.5,3,22.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M18.4,10.5v-6c0-0.8-0.7-1.5-1.5-1.5H4.5C3.7,3,3,3.7,3,4.5v6H18.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 19.7,
    cy: 1.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 19.7,
    cy: 25.3,
    r: 0.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1.6,
    cy: 1.8,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 1.6,
    cy: 25.3,
    r: 0.5
  })), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 1.1,
    width: 11.4,
    x: 5,
    y: 28.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.5,8.1l0.4-0.6C6.2,7.8,6.6,8,7.1,8c0.4,0,0.7-0.2,0.7-0.4c0-0.7-2.2-0.2-2.2-1.6c0-0.6,0.5-1.1,1.4-1.1     c0.6,0,1.1,0.2,1.5,0.5L8.1,6C7.8,5.7,7.4,5.6,7,5.6C6.7,5.6,6.5,5.7,6.5,6c0,0.6,2.2,0.2,2.2,1.6c0,0.7-0.5,1.2-1.5,1.2     C6.3,8.7,5.8,8.5,5.5,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.8,8.1l0.4-0.6C9.5,7.8,9.9,8,10.4,8c0.4,0,0.7-0.2,0.7-0.4c0-0.7-2.2-0.2-2.2-1.6c0-0.6,0.5-1.1,1.4-1.1     c0.6,0,1.1,0.2,1.5,0.5L11.4,6c-0.3-0.3-0.7-0.4-1.1-0.4C10,5.6,9.8,5.7,9.8,6c0,0.6,2.2,0.2,2.2,1.6c0,0.7-0.5,1.2-1.5,1.2     C9.7,8.7,9.2,8.5,8.8,8.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.4,8.6V4.9h1.5c1.2,0,2,0.7,2,1.9c0,1.1-0.8,1.9-2,1.9h-1.5V8.6z M15.1,6.8c0-0.7-0.4-1.2-1.2-1.2h-0.7     v2.3h0.7C14.7,7.9,15.1,7.4,15.1,6.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 5.2,
    y: 28.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 5.8,
    y: 28.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 6.3,
    y: 28.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 6.9,
    y: 28.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 7.5,
    y: 28.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 8,
    y: 28.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 8.6,
    y: 28.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 9.1,
    y: 28.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 9.7,
    y: 28.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 10.2,
    y: 28.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 10.8,
    y: 28.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 11.3,
    y: 28.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 11.9,
    y: 28.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 12.4,
    y: 28.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 13.5,
    y: 28.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 14.1,
    y: 28.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 14.6,
    y: 28.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 15.2,
    y: 28.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st6",
    height: 0.7,
    width: 0.4,
    x: 15.8,
    y: 28.1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 2.2,
    width: 0.2,
    x: 7,
    y: 15.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 2.2,
    width: 0.8,
    x: 7.5,
    y: 15.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 2.2,
    width: 0.6,
    x: 8.5,
    y: 15.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 2.2,
    width: 0.3,
    x: 9.3,
    y: 15.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 2.2,
    width: 1,
    x: 9.9,
    y: 15.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 2.2,
    width: 0.4,
    x: 11.1,
    y: 15.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 2.2,
    width: 0.2,
    x: 11.7,
    y: 15.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 2.2,
    width: 0.7,
    x: 12.1,
    y: 15.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 2.2,
    width: 0.3,
    x: 12.9,
    y: 15.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 2.2,
    width: 0.2,
    x: 13.4,
    y: 15.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    height: 2.2,
    width: 0.6,
    x: 13.8,
    y: 15.6
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiskDrive);
export default __webpack_public_path__ + "static/media/diskDrive.43fc6520538d92828bbe74098d54abb5.svg";
export { ForwardRef as ReactComponent };